var map = {
	"./README.md": 5785,
	"./_template-gotcha.md": 3149,
	"./_template-howto.md": 3418,
	"./_template.md": 3520,
	"./admin/communications/editing-email-templates.md": 8146,
	"./admin/communications/index.md": 9593,
	"./admin/communications/scheduled-jobs.md": 3059,
	"./admin/documents-and-compliance/documents-ai-settings.md": 7981,
	"./admin/documents-and-compliance/index.md": 3330,
	"./admin/finance/connecting-xero.md": 3543,
	"./admin/finance/index.md": 4998,
	"./admin/general-and-system/ai-settings-by-section.md": 480,
	"./admin/general-and-system/creating-a-custom-role.md": 4270,
	"./admin/general-and-system/giving-someone-roles.md": 8807,
	"./admin/general-and-system/giving-support-access.md": 4463,
	"./admin/general-and-system/index.md": 2786,
	"./admin/general-and-system/regional-holiday-lists.md": 5036,
	"./admin/general-and-system/roles-and-permissions.md": 9730,
	"./admin/general-and-system/roles-and-permissions/someone-cant-see-a-page.md": 6398,
	"./admin/general-and-system/your-logo-and-look.md": 175,
	"./admin/rostering-and-workforce/geofencing.md": 6583,
	"./admin/rostering-and-workforce/hr-note-types.md": 265,
	"./admin/rostering-and-workforce/index.md": 7952,
	"./admin/system-tools/diagnosing-failed-clock-ins.md": 2062,
	"./admin/system-tools/index.md": 4839,
	"./office/accounts/checking-invoices-before-sending.md": 8775,
	"./office/accounts/how-invoice-lines-are-calculated.md": 5193,
	"./office/accounts/index.md": 7321,
	"./office/accounts/invoicing-shifts-with-more-than-one-worker.md": 1606,
	"./office/documents/asking-the-policies-ai.md": 3530,
	"./office/documents/checking-compliance.md": 8409,
	"./office/documents/executive-team.md": 1477,
	"./office/documents/finding-and-reading-policies.md": 1196,
	"./office/documents/getting-a-policy-approved.md": 8200,
	"./office/documents/getting-a-policy-approved/make-active-not-available.md": 6630,
	"./office/documents/index.md": 905,
	"./office/documents/management-team.md": 3342,
	"./office/documents/ndis-commission-updates.md": 4934,
	"./office/documents/organising-folders.md": 8986,
	"./office/documents/updating-or-archiving-a-policy.md": 2646,
	"./office/documents/writing-a-policy.md": 1082,
	"./office/documents/writing-a-policy/autosave-paused.md": 326,
	"./office/documents/writing-a-policy/word-import-problems.md": 7320,
	"./office/hr/index.md": 8623,
	"./office/hr/notes-on-a-staff-record.md": 1525,
	"./office/hr/staff-missing-critical-documents.md": 1091,
	"./office/ndis-management/assigning-a-sil-team.md": 7307,
	"./office/ndis-management/checking-a-participants-budget.md": 9442,
	"./office/ndis-management/closing-an-incident.md": 9040,
	"./office/ndis-management/contact-via-guardian-only.md": 3965,
	"./office/ndis-management/deleting-a-draft-document.md": 8299,
	"./office/ndis-management/index.md": 1777,
	"./office/ndis-management/logging-an-incident.md": 5697,
	"./office/ndis-management/merging-duplicate-participants.md": 7397,
	"./office/ndis-management/ndis-management-dashboard.md": 5398,
	"./office/ndis-management/office-notes-on-a-participant.md": 557,
	"./office/ndis-management/participant-check-ins.md": 1252,
	"./office/ndis-management/participant-holiday-list.md": 2686,
	"./office/ndis-management/participant-record-layout.md": 247,
	"./office/ndis-management/participant-shift-notes.md": 1717,
	"./office/ndis-management/setting-up-service-agreement-supports.md": 8277,
	"./office/ndis-management/setting-up-service-agreement-supports/support-dates-outside-agreement.md": 1626,
	"./office/ndis-management/signing-a-service-agreement.md": 679,
	"./office/ndis-management/updating-a-plan-from-the-profile.md": 8868,
	"./office/organisation/index.md": 2775,
	"./office/rostering/applying-a-roster-template.md": 2379,
	"./office/rostering/applying-a-roster-template/shifts-not-filled.md": 6312,
	"./office/rostering/approving-timesheets.md": 7740,
	"./office/rostering/creating-a-shift.md": 2196,
	"./office/rostering/creating-a-shift/worker-cant-see-a-job-board-shift.md": 4414,
	"./office/rostering/creating-linked-shifts.md": 1903,
	"./office/rostering/emailing-staff-and-participants.md": 8334,
	"./office/rostering/finding-contact-details-on-the-roster.md": 3289,
	"./office/rostering/index.md": 782,
	"./office/rostering/repeating-shifts.md": 9085,
	"./office/rostering/roster-templates.md": 7045,
	"./office/rostering/seeing-which-workers-are-on-templates.md": 2874,
	"./office/rostering/sending-a-bulk-email.md": 8994,
	"./office/rostering/sending-an-sms.md": 6406,
	"./participant/documents-and-signing/index.md": 8118,
	"./participant/documents-and-signing/signing-a-document.md": 9877,
	"./participant/documents-and-signing/signing-a-document/signing-link-problems.md": 811,
	"./participant/my-team/index.md": 3286,
	"./participant/roster/index.md": 9409,
	"./participant/your-account/index.md": 2567,
	"./worker/leave-and-availability/index.md": 2366,
	"./worker/leave-and-availability/requesting-leave.md": 1790,
	"./worker/leave-and-availability/requesting-leave/notice-and-approval.md": 5586,
	"./worker/participants/index.md": 5449,
	"./worker/participants/who-appears-in-my-participants.md": 4298,
	"./worker/roster-and-job-board/index.md": 683,
	"./worker/roster-and-job-board/picking-up-shifts-from-the-job-board.md": 348,
	"./worker/roster-and-job-board/picking-up-shifts-from-the-job-board/cant-see-a-shift.md": 9032,
	"./worker/roster-and-job-board/picking-up-shifts-from-the-job-board/clashes-and-short-notice.md": 8750,
	"./worker/shifts/claiming-expenses.md": 6444,
	"./worker/shifts/claiming-km.md": 8217,
	"./worker/shifts/clock-in-and-out.md": 6967,
	"./worker/shifts/clock-in-and-out/location-blocked.md": 9308,
	"./worker/shifts/index.md": 2058,
	"./worker/shifts/linked-shifts.md": 5335,
	"./worker/shifts/logging-awake-time.md": 9811,
	"./worker/shifts/reporting-an-incident.md": 9657,
	"./worker/shifts/shift-notes.md": 7338,
	"./worker/shifts/shifts-with-more-than-one-worker.md": 7816,
	"./worker/shifts/submitting-your-timesheet.md": 2787,
	"./worker/your-account/index.md": 6002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9884;